import gql from 'graphql-tag';

import { getHomeUrl } from 'bundles/common/utils/courseUrl';
import type { NormalizedInProgressCourse } from 'bundles/degree-home/components/v2/types/courseStates';
import type { DegreeCourse } from 'bundles/degree-home/types/Course';

export function getCourseLink(course: DegreeCourse | NormalizedInProgressCourse | { slug: string }): string {
  return getHomeUrl(`/learn/${course.slug}`);
}
getCourseLink.fragment = gql`
  fragment CourseLinkFragment on DegreeLearnerProgressesV1_org_coursera_degree_learner_sequence_Course {
    slug
  }
`;
